import { styled } from "@mui/material";

const Styled = {};

Styled.FunctionBoxContainer = styled("div")(() => ({
    width: 'fit-content',
    height: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 40,
    cursor: 'pointer',
    paddingBottom: 3
}));

export default Styled;